module.exports = __webpack_public_path__ + "static/media/uveret.62a59ef4.mp3";